import { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { gql, useMutation } from "@apollo/client";

import Image from "@/components/Image";
import { useUser } from "@/components/contexts/user";

import styles from "@/styles/LoginPage.module.css";

function LoginPage() {
  // Handles logging in
  const [login, { data, error }] = useMutation(pageMutation);
  // For the form
  const userRef = useRef();
  const passwordRef = useRef();
  const router = useRouter();
  const { isAuthenticated, id, refetch } = useUser();

  async function handleSubmit(e) {
    e.preventDefault();
    const username = userRef.current.value;
    const password = passwordRef.current.value;
    login({
      variables: {
        username: username,
        password: password,
      },
    });
    const response = await fetch("/api/login/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    credentials: "include",
    body: JSON.stringify({username, password})
    });

    if (response.ok) {
    window.location.href = "/";
    } else {
    console.error("Login failed"); 
    }
  };

  useEffect(() => {
    if (isAuthenticated) router.push({ pathname: "/dj/[id]", query: { id } });
  }, [id, isAuthenticated, router]);

  useEffect(() => {
    if (data && data.login.user.isAuthenticated) refetch();
  }, [data, refetch]);

  return (
    <main className={`${styles.login} text-center`}>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <Image
            width={865}
            height={503}
            src="/static/main/images/logo-yellow.png"
            alt="91.7 KVRX"
            priority={true}
          />
        </div>
        <h1 className="h3 mb-3 fw-normal">Log in</h1>

        <p className="text-warning">
          {error?.graphQLErrors?.map(({ message }) => {
            return message + "\n";
          })}
        </p>
        <div className="form-floating mb-3">
          <input
            type="username"
            className="form-control"
            id="floatingInput"
            placeholder=""
            ref={userRef}
          />
          <label htmlFor="floatingInput">Username</label>
        </div>
        <div className="form-floating mb-5">
          <input
            type="password"
            className="form-control"
            id="floatingPassword"
            placeholder="Password"
            ref={passwordRef}
          />
          <label htmlFor="floatingPassword">Password</label>
        </div>

        <button className="w-100 btn btn-lg btn-primary" type="submit">
          Log in
        </button>
      </form>
    </main>
  );
}

// LoginPage.Layout = ({ children }) => <div>{children}</div>;

export default LoginPage;

const pageMutation = gql`
  mutation LoginUser($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      user {
        isAuthenticated
      }
    }
  }
`;
